<template>
  <div class="price-format" :class="[size]" :style="{ color: color }">
    <span class="price-icon">{{ currency }}</span>
    <span class="price-int">{{ priceInt }}</span>
    <span class="price-dot">.</span>
    <span class="price-decimal">{{ priceDecimal }}</span>
  </div>
</template>

<script>
export default {
  props: {
    currency: {
      type: String,
      default: "￥",
    },
    value: {
      type: [String, Number],
      default: "0",
    },
    size: {
      type: String,
      default: "default",
    },
    color: {
      type: String,
      default: "#f20",
    },
  },
  computed: {
    priceInt() {
      const price = this.value + "";
      let priceInt = "0";
      if (price && price.indexOf(".")) {
        const arr = price.split(".");
        priceInt = arr[0];
      }
      return priceInt;
    },
    priceDecimal() {
      const price = this.value + "";
      let priceDecimal = "00";
      if (price && price.indexOf(".")) {
        const arr = price.split(".");
        priceDecimal = arr[1];
      }
      if (!priceDecimal) {
        priceDecimal = "00";
      }
      return priceDecimal;
    },
  },
};
</script>

<style lang="less" scoped>
.price-format {
  display: inline-block;
  &.xxl {
    .price-icon {
      font-size: 24px;
    }
    .price-int {
      font-size: 34px;
    }
    .price-decimal {
      font-size: 24px;
    }
  }
  &.large {
    .price-icon {
      font-size: 16px;
    }
    .price-int {
      font-size: 26px;
    }
    .price-decimal {
      font-size: 16px;
    }
  }
  &.default {
    .price-icon {
      font-size: 14px;
    }
    .price-int {
      font-size: 20px;
    }
    .price-decimal {
      font-size: 14px;
    }
  }
  &.small {
    .price-icon {
      font-size: 12px;
    }
    .price-int {
      font-size: 18px;
    }
    .price-decimal {
      font-size: 12px;
    }
  }
}
</style>
